import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-movimentacao-societaria-mudar-status-modal',
  templateUrl: './movimentacao-societaria-mudar-status-modal.component.html',
  styleUrl: './movimentacao-societaria-mudar-status-modal.component.scss'
})
export class MovimentacaoSocietariaMudarStatusModalComponent {

  @Input() movimentacao: any;
  @Input() acao: any;
  justificativaForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit(): void {
    this.buildForm();
    // console.log(this.movimentacao);
  }

  buildForm(): void {
    this.justificativaForm = this.fb.group({
      textoJustificativa: ['']
    });
  }

  salvarObservacoes(): void {
    const textoJustificativa = this.justificativaForm.get('textoJustificativa')?.value;
    this.modalRef.close(textoJustificativa);
    }

  fecharModal(): void {
    this.modalRef.close();
  }
}
